function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M256 199.305l-127.957-18.797L0 199.329l128.01 47.439L256 199.305",
  fill: "#B7CA9D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.621 197.113l21.63 6.761 1.971-2.238V50.284l-1.971-2.585-21.63 8.274v141.14",
  fill: "#4B612C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M123.832 190.423l-76.581 13.451V47.703l76.581 17.222v125.498",
  fill: "#759C3E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M89.686 216.889l-29.848-9.201V14.928L89.686.004l2.612 2.845v210.858l-2.612 3.182",
  fill: "#4B612C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M191.967 192.894L89.686 216.889V0l102.281 39.866v153.028",
  fill: "#759C3E"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M127.965 244.714L0 199.329v26.324l127.965 63.983v-44.922",
  fill: "#4B612C"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M256 225.622l-128.035 64.014v-44.922L256 199.305v26.317",
  fill: "#759C3E"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M220.039 155.692h-31.026l-88.445 6.026L128 166.775l92.039-11.083",
  fill: "#B7CA9D"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M100.568 219.906l27.42 8.226.789-.849-.023-61.849-.789-.758-27.397-2.958v58.188",
  fill: "#4B612C"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M220.039 155.692l-92.074 8.98.023 63.46 92.051-27.711v-44.729",
  fill: "#759C3E"
});

function SvgAwsCloudwatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2207,
    height: 2500,
    viewBox: "0 0 256 290",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCloudwatch);
export default __webpack_public_path__ + "static/media/aws-cloudwatch.0d01bd61.svg";
export { ForwardRef as ReactComponent };